import { getStorageItem } from "./utils";

export const buildCheckSumPayload = (checksum) => {
  return {
    checksum,
  };
};

export const buildOrderIdPayload = () => {
  return {
    oid: Number(getStorageItem("oid")),
  };
};

export const buildUpdateCustomerPayload = (
  {
    bank_account_holder_name,
    bank_account_number,
    bank_ifsc_code,
    bank_account_type,
    bank_micr_code,
  },
  { code, label }
) => {
  return {
    accountType: bank_account_type,
    bankAccountHolderName: bank_account_holder_name,
    bankAccountNumber: bank_account_number,
    bankCode: code,
    bankIFSCCode: bank_ifsc_code.toUpperCase(),
    bankMICRCode: bank_micr_code,
    bankName: label,
    cid: Number(getStorageItem("cid")),
    oid: Number(getStorageItem("oid")),
  };
};

export const buildVerifyBankAccountPayload = (
  { bank_account_holder_name, bank_account_number, bank_ifsc_code },
  checksum
) => {
  return {
    accountHolderName: bank_account_holder_name,
    accountNumber: bank_account_number,
    ifsc: bank_ifsc_code.toUpperCase(),
    oid: Number(getStorageItem("oid")),
    cid: Number(getStorageItem("cid")),
    checksum,
  };
};

export const buildUpdateSalesPersonPayload = (
  { code: sp_code = "" },
  { code: branch_code = "" },
  checksum
) => {
  return {
    oid: Number(getStorageItem("oid")),
    sp_code,
    branch_code,
    checksum,
  };
};
